if (!window.pajpApp || typeof window.pajpApp == "undefined") {
  window.pajpApp = {};
}
$(function () {
  window.pajpApp.check_sizes_preferences();
  window.pajpApp.check_sizes_chart();
});

/*pajp_docReady(function () {
  window.pajpApp.check_sizes_preferences();
  window.pajpApp.check_sizes_chart();

});*/

window.pajpApp.check_sizes_chart = function(){
  
	  var auto_code_sizes = document.querySelector('#pajp-sizes-automatic-code');
      var product_id = auto_code_sizes.getAttribute("data-pajp-product-id");
      var shop_id = auto_code_sizes.getAttribute("data-pajp-shop-id");
    
      axios.post('https://pajphost.com/customer/public/api/checkProductLayout', {
            
            product_id: product_id,
            shop_id: shop_id,
          })
          .then(function(response){
 
            if(response.data.length != 0){
              
				window.pajpApp.copy_sizes_btn();
             	window.pajpApp.addCLickEventSizeBtn();
              
              	response.data.forEach(function(item, index){
                  if(index == 0){
                    
                  	$('#titleModal').text(item.layout_title);
                    $('#bodyModal').html(item.code_html);
                    
                    //Activar conversor de unidades
                    if(item.has_table){
                    	$('#titleModal').after('<div class="btn-container pajp_sizes_switch_container"><label class="switch btn-color-mode-switch"><input onchange="changeMetric(this)" type="checkbox" name="color_mode" id="color_mode" value="1"><label for="color_mode" data-on="cm" data-off="in" class="btn-color-mode-switch-inner"></label></label> </div>');
                    }
                  }
                });
              	//crear el modal o clonarlo con el layout
            }
              
          })
          .catch(function(error){
              console.log(error);
          });
};

window.pajpApp.copy_sizes_btn = function(){
  
	  var addtocart_selectors = [".swatch"];
      addtocart_selectors.forEach(function (selector) {
        var els = document.getElementsByClassName("swatch");
        if (typeof els == "object" && els) {
          for (var i = 0; i < els.length; i++) {
            var el = els[i];

            if (typeof el.addEventListener != "function") {
              return;
            }

            el.after(document.getElementById('pajp-sizes-automatic-code').children[0], el.firstChild)

          }
        }
      });
};

window.pajpApp.addCLickEventSizeBtn = function(){
  
	var sizes_btn = document.querySelector('.pajp_sizes_btn');
  
  	sizes_btn.addEventListener('click', function(e){
    	// Get the modal
		var modal = document.getElementById("layout_container");
      	// Get the <span> element that closes the modal
		var span = document.getElementById("closeModal");
      
      	modal.style.display = "block";
      
      	// When the user clicks on <span> (x), close the modal
        span.onclick = function() {
          modal.style.display = "none";
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function(event) {
          if (event.target == modal) {
            modal.style.display = "none";
          }
        } 
    });
};

function changeMetric(e){
	//console.log(e);
  	var checkBoxMetric = $(e);
  
  	var bodyModal = $("#bodyModal");
  	var tablesModal = bodyModal.find("table");
    
  if(checkBoxMetric.is(":checked")){
  	//cm
    
    for(var i = 0; i < tablesModal.length; i++){
    	//console.log(tablesModal[i]);
      	var tablesModalItem = $(tablesModal[i]);
      
      	//ver desde que columna hay que recorrer
      	var colStart = 0;
  		var headerCol = tablesModalItem.find("th span");
      	var headerPos = 0;
      	var stop = false;
      
        while(!stop && headerPos<headerCol.length){
			if(headerCol[headerPos].textContent.includes("Size") || headerCol[headerPos].textContent.includes("size")){
            	colStart++;
            }else{
            	stop = true;
            }
          	headerPos++;
        }
      
      
        if(tablesModalItem.hasClass("is-inch")){
			//console.log("Hay que convertir a cm");
          
            tablesModalItem.removeClass("is-inch");
            tablesModalItem.addClass("is-cm");
          
          
          	var rows = tablesModalItem.find("tr");
          
            for (var j = 0, row; row = rows[j]; j++) {
              
              var cells = $(row).find("td");
               
               for (var k = colStart, col; col = cells[k]; k++) {
                 
                 var spanCell = $(col).find('span')[0];
                 var cellItem = $(spanCell);
                 
                 if(cellItem.text().includes("<") || cellItem.text().includes(">")){
                 	var firstChar = cellItem.text()[0];
                    var realValue = cellItem.text().substring(1);
                   	var convertValue = (parseFloat(realValue)* 2.54).toFixed(2);
                   
                    cellItem.text(firstChar + "" + convertValue);
                   
                 }else if(cellItem.text().includes("-")){
                 	//Dividir la cadena por el caracter - y convertir cada uno y luego crear la cadena de nuevo
                   	var splittedValues = cellItem.text().split("-");
                   	
                     splittedValues.forEach(function(item, index){
						splittedValues[index] = (parseFloat(item)* 2.54).toFixed(2)
                     });
                   
                   	cellItem.text(splittedValues.join("-"));
                 }else{
                 	cellItem.text((parseFloat(cellItem.text())* 2.54).toFixed(2));
                 }
                 
               }  
            }
          
        }
    }
    
  }else{
  	//inch
    
    for(var i = 0; i < tablesModal.length; i++){
    	//console.log(tablesModal[i]);
      	var tablesModalItem = $(tablesModal[i]);
      
      	//ver desde que columna hay que recorrer
      	var colStart = 0;
  		var headerCol = tablesModalItem.find("th span");
      	var headerPos = 0;
      	var stop = false;
      
        while(!stop && headerPos<headerCol.length){
			if(headerCol[headerPos].textContent.includes("Size") || headerCol[headerPos].textContent.includes("size")){
            	colStart++;
            }else{
            	stop = true;
            }
          	headerPos++;
        	}
      
        if(tablesModalItem.hasClass("is-cm")){
			//console.log("Hay que convertir a inch");
          
            tablesModalItem.removeClass("is-cm");
            tablesModalItem.addClass("is-inch");
          
          
          	var rows = tablesModalItem.find("tr");
          
            for (var j = 0, row; row = rows[j]; j++) {
              
              var cells = $(row).find("td");
               
               for (var k = colStart, col; col = cells[k]; k++) {
                 
                 var spanCell = $(col).find('span')[0];
                 var cellItem = $(spanCell);
                 
                 if(cellItem.text().includes("<") || cellItem.text().includes(">")){
                 	var firstChar = cellItem.text()[0];
                    var realValue = cellItem.text().substring(1);
                   	var convertValue = (parseFloat(realValue)/ 2.54).toFixed(2);
                   
                    cellItem.text(firstChar + "" + convertValue);
                   
                 }else if(cellItem.text().includes("-")){
                 	//Dividir la cadena por el caracter - y convertir cada uno y luego crear la cadena de nuevo
                   	var splittedValues = cellItem.text().split("-");
                   	
                     splittedValues.forEach(function(item, index){
						splittedValues[index] = (parseFloat(item)/ 2.54).toFixed(2)
                     });
                   
                   	cellItem.text(splittedValues.join("-"));
                   
                 }else{
                 	cellItem.text((parseFloat(cellItem.text())/ 2.54).toFixed(2));
                 }

               }  
            }
          
        }
    }
    
  }
}

window.pajpApp.check_sizes_preferences = function(){
  var current_variants = JSON.parse(localStorage.getItem('pajp_current_variants'));
  //Hay que ver como identificar cada producto a que preferences pertenece que por ahora hay Top, Bottom y Shoe
  //Probablemente habrá que agregar esto en el backend para asociar cada producto a estas categorias
  
  //Se van a usar los tags
  var auto_code_sizes = document.querySelector('#pajp-sizes-automatic-code');
  var product_id = auto_code_sizes.getAttribute("data-pajp-product-id");
  var shop_id = auto_code_sizes.getAttribute("data-pajp-shop-id");
  var customer_id = document.querySelector("#customer_id").value;
  
  axios.post('/apps/pajp_customer/customers/'+customer_id+'/checkSizesPreferences', {
            
            product_id: product_id,
            shop_id: shop_id,
    		customer_id: customer_id
          })
          .then(function(response){
 			//console.log(response);
            if(response.data.length != 0){
              	
				//Hay que ver si existe la option que viene
              	var preferSize = response.data[0];
              	var exists = 0 != $('select.sized option[value='+preferSize+']').length;
              
              if(exists){
              	$('select.sized').val(preferSize);

                //buscar y cambiar el id del variant
                var founded = false;
                var i = 0;
                var variant_id = "";
                while(!founded && i < current_variants.length){
                  if(current_variants[i]['option1'] == preferSize || current_variants[i]['option2'] == preferSize || current_variants[i]['option3'] == preferSize){
                    founded = true;
                    variant_id = current_variants[i]['id'];
                  }
                  i++;
                }
                if(variant_id != ""){
                  $('.pajp-add-to-wsl-btn').attr('data-pajp-variant-id', variant_id);
                  $("select[id*='ProductSelect']").val(variant_id); 
                }
              }
            }
            window.pajpApp.check_wishlist();  
          })
          .catch(function(error){
              console.log(error);
          });
}